var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/forbid-prop-types */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
/* globals i18n */
var classNames = require("classnames");
var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");

var _require = require("../icon-paths.js"),
    iconOk = _require.iconOk,
    iconRemove = _require.iconRemove;

var InlineIcon = require("../components/inline-icon.jsx");
var Renderer = require("../renderer.jsx");
var GradedGroupAnswerBar = require("./graded-group-answer-bar.jsx");

var _require2 = require("../styles/constants.js"),
    gray76 = _require2.gray76,
    phoneMargin = _require2.phoneMargin,
    negativePhoneMargin = _require2.negativePhoneMargin,
    tableBackgroundAccent = _require2.tableBackgroundAccent,
    kaGreen = _require2.kaGreen;

var _require3 = require("aphrodite"),
    StyleSheet = _require3.StyleSheet,
    css = _require3.css;

var _require4 = require("../gorgon/proptypes.js"),
    linterContextProps = _require4.linterContextProps,
    linterContextDefault = _require4.linterContextDefault;

// A Graded Group is more or less a Group widget that displays a check
// answer button below the rendered content. When clicked, the widget grades
// the stuff inside and displays feedback about whether the inputted answer was
// correct or not.

var GRADING_STATUSES = {
    ungraded: "ungraded",
    correct: "correct",
    incorrect: "incorrect",
    invalid: "invalid"
};

var ANSWER_BAR_STATES = GradedGroupAnswerBar.ANSWER_BAR_STATES;

// Update answer bar state based on current state and whether the question is
// answerable (all parts have been filled out) or not.
var getNextState = function getNextState(currentState, answerable) {
    switch (currentState) {
        case ANSWER_BAR_STATES.HIDDEN:
            return answerable ? ANSWER_BAR_STATES.ACTIVE : currentState;
        case ANSWER_BAR_STATES.ACTIVE:
            return !answerable ? ANSWER_BAR_STATES.INACTIVE : currentState;
        case ANSWER_BAR_STATES.INACTIVE:
            return answerable ? ANSWER_BAR_STATES.ACTIVE : currentState;
        case ANSWER_BAR_STATES.INCORRECT:
            return answerable ? ANSWER_BAR_STATES.ACTIVE : ANSWER_BAR_STATES.INACTIVE;
        default:
            return currentState;
    }
};

// Prepended to all invalid messages to make the widget messages a bit clearer
var INVALID_MESSAGE_PREFIX = "We couldn't grade your answer.";
var DEFAULT_INVALID_MESSAGE = "It looks like you left something blank or " + "entered in an invalid answer.";

var GradedGroup = React.createClass({
    displayName: "GradedGroup",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        content: React.PropTypes.string,
        hasHint: React.PropTypes.bool,
        hint: React.PropTypes.object,
        images: React.PropTypes.object,
        inGradedGroupSet: React.PropTypes.bool,
        onBlur: React.PropTypes.func,
        onFocus: React.PropTypes.func,

        // The function to call when clicking "Next question" after correctly
        // answering one graded group out of a set. If this is null, the
        // "Next question" button will not appear.
        onNextQuestion: React.PropTypes.func,

        title: React.PropTypes.string,
        trackInteraction: React.PropTypes.func.isRequired,
        widgets: React.PropTypes.object,
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            title: "",
            content: "",
            widgets: {},
            images: {},
            hint: null,
            hasHint: false,
            linterContext: linterContextDefault
        };
    },

    getInitialState: function getInitialState() {
        return {
            status: GRADING_STATUSES.ungraded,
            showHint: false,
            message: "",
            answerBarState: ANSWER_BAR_STATES.HIDDEN
        };
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return nextProps !== this.props || nextState !== this.state;
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    // This is a little strange because the id of the widget that actually
    // changed is going to be lost in favor of the group widget's id. The
    // widgets prop also wasn't actually changed, and this only serves to
    // alert our renderer (our parent) of the fact that some interaction
    // has occurred.
    _onInteractWithWidget: function _onInteractWithWidget(id) {
        // Reset grading display when user changes answer
        this.setState({
            status: GRADING_STATUSES.ungraded,
            message: ""
        });

        if (this.refs.renderer) {
            this.change("widgets", this.props.widgets);
            var emptyWidgets = this.refs.renderer.emptyWidgets();
            var answerable = emptyWidgets.length === 0;
            var answerBarState = this.state.answerBarState;
            this.setState({
                answerBarState: getNextState(answerBarState, answerable)
            });
        }
    },

    _checkAnswer: function _checkAnswer() {
        this.refs.renderer.showRationalesForCurrentlySelectedChoices();
        var score = this.refs.renderer.score();

        var status = void 0;
        var message = void 0;
        if (score.type === "points") {
            status = score.total === score.earned ? GRADING_STATUSES.correct : GRADING_STATUSES.incorrect;
            message = score.message || "";
        } else {
            // score.type is "invalid"
            status = GRADING_STATUSES.invalid;
            message = score.message ? INVALID_MESSAGE_PREFIX + " " + score.message : INVALID_MESSAGE_PREFIX + " " + DEFAULT_INVALID_MESSAGE;
        }

        this.setState({
            status: status,
            message: message,
            // TODO(kevinb) handle 'invalid' status
            answerBarState: status === "correct" ? ANSWER_BAR_STATES.CORRECT : ANSWER_BAR_STATES.INCORRECT
        });

        this.props.trackInteraction({
            status: status
        });
    },

    // Mobile API
    getInputPaths: function getInputPaths() {
        return this.refs.renderer.getInputPaths();
    },

    setInputValue: function setInputValue(path, newValue, cb) {
        return this.refs.renderer.setInputValue(path, newValue, cb);
    },

    getAcceptableFormatsForInputPath: function getAcceptableFormatsForInputPath(path) {
        return this.refs.renderer.getAcceptableFormatsForInputPath(path);
    },

    focus: function focus() {
        return this.refs.renderer.focus();
    },

    focusInputPath: function focusInputPath(path) {
        this.refs.renderer.focusPath(path);
    },

    blurInputPath: function blurInputPath(path) {
        this.refs.renderer.blurPath(path);
    },

    render: function render() {
        var _this = this,
            _classNames;

        var apiOptions = _.extend({}, ApiOptions.defaults, this.props.apiOptions, {
            // Api Rewriting to support correct onFocus/onBlur
            // events for the mobile API
            onFocusChange: function onFocusChange(newFocus, oldFocus) {
                if (oldFocus) {
                    _this.props.onBlur(oldFocus);
                }
                if (newFocus) {
                    _this.props.onFocus(newFocus);
                }
            }
        });

        var icon = null;
        // Colors are 10% darker than the colors in graded-group.less
        if (this.state.status === GRADING_STATUSES.correct) {
            icon = React.createElement(InlineIcon, _extends({}, iconOk, { style: { color: "#526f03" } }));
        } else if (this.state.status === GRADING_STATUSES.incorrect) {
            icon = React.createElement(InlineIcon, _extends({}, iconRemove, { style: { color: "#ff5454" } }));
        }

        var mobileClass = this.props.inGradedGroupSet ? css(styles.gradedGroupInSet) : css(styles.gradedGroup);

        var classes = classNames((_classNames = {}, _classNames[mobileClass] = apiOptions.isMobile, _classNames["perseus-graded-group"] = true, _classNames["answer-correct"] = apiOptions.isMobile ? false : this.state.status === GRADING_STATUSES.correct, _classNames["answer-incorrect"] = apiOptions.isMobile ? false : this.state.status === GRADING_STATUSES.incorrect, _classNames));

        var answerBarState = this.state.answerBarState;

        // Disabled widgets after the answer has been answered correctly to
        // prevent a situation where the answer has been marked correct but
        // looks incorrect because a user has modified it afterwards.

        var isCorrect = answerBarState === ANSWER_BAR_STATES.CORRECT;
        var readOnly = apiOptions.readOnly || apiOptions.isMobile && isCorrect;

        return React.createElement(
            "div",
            { className: classes },
            !!this.props.title && React.createElement(
                "div",
                { className: css(styles.title) },
                this.props.title
            ),
            React.createElement(Renderer, _extends({}, this.props, {
                ref: "renderer",
                apiOptions: _extends({}, apiOptions, { readOnly: readOnly }),
                onInteractWithWidget: this._onInteractWithWidget,
                linterContext: this.props.linterContext
            })),
            !apiOptions.isMobile && icon && React.createElement(
                "div",
                { className: "group-icon" },
                icon
            ),
            !apiOptions.isMobile && React.createElement(
                "p",
                null,
                this.state.message
            ),
            !apiOptions.isMobile && React.createElement("input", {
                type: "button",
                value: i18n._("Check"),
                className: "simple-button",
                disabled: this.props.apiOptions.readOnly,
                onClick: this._checkAnswer
            }),
            !apiOptions.isMobile && isCorrect && this.props.onNextQuestion && React.createElement("input", {
                type: "button",
                value: i18n._("Next question"),
                className: "simple-button",
                disabled: this.props.apiOptions.readOnly,
                onClick: this.props.onNextQuestion,
                style: { marginLeft: 5 }
            }),
            this.props.hint && this.props.hint.content && (this.state.showHint ? React.createElement(
                "div",
                null,
                React.createElement(
                    "div",
                    {
                        className: css(styles.explanationTitle),
                        onClick: function onClick() {
                            return _this.setState({ showHint: false });
                        }
                    },
                    i18n._("Hide explanation")
                ),
                React.createElement(Renderer, _extends({}, this.props.hint, {
                    ref: "hints-renderer",
                    apiOptions: apiOptions,
                    linterContext: this.props.linterContext
                }))
            ) : React.createElement(
                "div",
                {
                    onClick: function onClick() {
                        return _this.setState({ showHint: true });
                    },
                    className: css(styles.showHintLink)
                },
                i18n._("Explain")
            )),
            apiOptions.isMobile && answerBarState !== ANSWER_BAR_STATES.HIDDEN && React.createElement(GradedGroupAnswerBar, {
                apiOptions: apiOptions,
                answerBarState: answerBarState,
                onCheckAnswer: this._checkAnswer,
                onNextQuestion: this.props.onNextQuestion
            })
        );
    }
});

var traverseChildWidgets = function traverseChildWidgets(props, traverseRenderer) {
    return _.extend({}, props, traverseRenderer(props));
};

module.exports = {
    name: "graded-group",
    displayName: "Graded group (articles only)",
    widget: GradedGroup,
    traverseChildWidgets: traverseChildWidgets,
    // TODO(aasmund): This widget should be available for articles only
    hidden: false,
    tracking: "all",
    isLintable: true
};

var styles = StyleSheet.create({
    gradedGroupInSet: {
        // Reset a few desktop-only styles that come from graded-group.less
        marginLeft: 0,
        paddingLeft: 0
    },

    gradedGroup: {
        borderTop: "1px solid " + gray76,
        borderBottom: "1px solid " + gray76,
        backgroundColor: tableBackgroundAccent,
        marginLeft: negativePhoneMargin,
        marginRight: negativePhoneMargin,
        paddingBottom: phoneMargin,
        paddingLeft: phoneMargin,
        paddingRight: phoneMargin,
        paddingTop: 10,
        width: "auto"
    },

    showHintLink: {
        marginTop: 20,
        color: kaGreen,
        cursor: "pointer"
    },

    explanationTitle: {
        marginTop: 20,
        color: kaGreen,
        marginBottom: 10,
        cursor: "pointer"
    },

    title: {
        fontSize: 12,
        color: gray76,
        textTransform: "uppercase",
        marginBottom: 11,
        letterSpacing: 0.8
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/graded-group.jsx
 ** module id = 106
 ** module chunks = 0 1
 **/